export const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        gap: [2, 2, 4],
        pb: ["20px", "20px", "40px"],
        mx: [3, 3, 4, 6],
    },
    descriptionContainer: {
        width: ["100%", "100%", "75%", "50%"],
    },
    description: {
        fontSize: ["desktopBodyTextSmall", "desktopBodyTextSmall", "desktopBodyTextNormal"],
        fontWeight: "normal",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
};
